import moment from "moment";
import { BADGE_COLORS } from "../../../components/ui/badgeColors";
import { ORDER_STATE_COMPRAS } from "../../../config/constants";

/**
 * Helpers del listado de estados de compras: filas del DataGrid, color por estado
 * y formatos compartidos por la tabla y la lista móvil.
 */

const VALOR_VACIO = "-";

// DECISION: SIN_INICIAR=BLUE (equivale a "Sin preparar": información / estado inicial),
// RECEPCIONADO=INDIGO (intermedio, distinto de BLUE; no GREEN porque verde significa completado),
// EN_PROCESO=AMBER (en proceso) y COMPLETO=GREEN (éxito).
export const COLOR_ESTADO_COMPRA = {
    SIN_INICIAR: BADGE_COLORS.BLUE,
    RECEPCIONADO: BADGE_COLORS.INDIGO,
    EN_PROCESO: BADGE_COLORS.AMBER,
    COMPLETO: BADGE_COLORS.GREEN,
};

/**
 * Color de la paleta para un estado de compra; GRAY si es desconocido o nulo
 */
export const getColorEstadoCompra = (estado) =>
    (Object.keys(ORDER_STATE_COMPRAS).includes(estado) && COLOR_ESTADO_COMPRA[estado]) || BADGE_COLORS.GRAY;

/**
 * Etiqueta legible del estado; el valor crudo si es desconocido, "-" si no hay
 */
export const getEtiquetaEstadoCompra = (estado) =>
    ORDER_STATE_COMPRAS[estado] || estado || VALOR_VACIO;

// Un 0 es un dato válido: solo null/undefined/NaN se consideran ausencia
const aNumeroONull = (valor) => (valor === null || valor === undefined ? null : valor);

/**
 * Convierte los pedidos del backend en filas del DataGrid.
 * id = numeroPedido; pendientes y productos conservan el 0 (null si faltan).
 */
export const prepararFilasEstadosCompras = (pedidos) => {
    if (!Array.isArray(pedidos)) return [];
    return pedidos.map((pedido) => ({
        ...pedido,
        id: pedido.numeroPedido,
        pendientes: aNumeroONull(pedido.faltanTotales),
        productos: Array.isArray(pedido.faltanPorProducto) ? pedido.faltanPorProducto.length : null,
    }));
};

/**
 * Fecha DD/MM/YYYY, "-" si es nula o inválida
 */
export const formatFechaCompra = (valor) => {
    if (!valor) return VALOR_VACIO;
    const fecha = moment(valor);
    return fecha.isValid() ? fecha.format("DD/MM/YYYY") : VALOR_VACIO;
};

/**
 * Fecha y hora DD/MM/YYYY HH:mm, "-" si es nula o inválida
 */
export const formatFechaHoraCompra = (valor) => {
    if (!valor) return VALOR_VACIO;
    const fecha = moment(valor);
    return fecha.isValid() ? fecha.format("DD/MM/YYYY HH:mm") : VALOR_VACIO;
};

/**
 * Cantidad con el 0 visible; "-" solo si es null/undefined
 */
export const formatCantidadCompra = (valor) =>
    valor === null || valor === undefined ? VALOR_VACIO : valor;

/**
 * Texto o "-" si está vacío
 */
export const formatTextoCompra = (valor) => valor || VALOR_VACIO;
